const Genre = {
    values: {
        'abstract': { display: 'Abstract', value: 2 },
        'conceptual': { display: 'Conceptual', value: 1 },
        'landscape': { display: 'Landscape', value: 3 },
        'stilllife': { display: 'Still-Life', value: 5 },
        'figurative': { display: 'Figurative', value: 4 }
    }
}

const Inventory = {
    Artwork: 0,
    Merchandise: 1,
    Jewelry: 5,
    Furniture: 6,
    Lighting: 7,
    Decor: 8
};

const Metric = {
    Inches: 0,
    Centimeters: 1,
    Feet: 2,

    getTypeDisplay: function (metric) {
        switch (metric) {
            case Metric.Centimeters:
                return 'Centimeters';
            case Metric.Feet:
                return 'Feet';
            case Metric.Inches:
                return 'Inches';
            default:
                return '';
        }
    }
}

const User = {
    Artist: 'Artist',
    Collector: 'Collector',
    Gallery: 'Gallery',
    Jewelry: 'Jewelry',

    getTypeDisplay: function (user) {
        if (!user.Type) {
            return '';
        }
        switch (user.Type.Name) {
            case User.Artist:
                return 'Studio';
            case User.Gallery:
                if (user.DefaultInventoryType && user.DefaultInventoryType.Value == Inventory.Jewelry) {
                    return 'Boutique';
                }
                return 'Gallery';
            default:
                return '';
        }
    },
    getValue: function (userType) {
        switch (userType) {
            case User.Artist:
                return 2;
            case User.Collector:
                return 6;
            case User.Gallery:
            case User.Jewelry:
                return 3;
        }
    }
}

export { Genre, Inventory, Metric, User };